import '../../../common/dashboard/filters/filter.js.coffee'
Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.SubTypeFilter extends Common.Dashboard.Filters.Filter
  @FILTER_TYPE: 'subtype'
  removable: true

  getFilterType: ->
    CustomerVisualMode.Filters.SubTypeFilter.FILTER_TYPE

  getValues: ->
    return [] unless @values
    @values.map((name) => {id: name, name: @_subtypeTranslator().getTranslation(name)})

  removeValue: (valueToRemove) ->
    @values = _.reject(@values, (value) -> value == valueToRemove.id)

  hasValues: ->
    @values.length != 0

  _valuesToJSON: ->
    @values

  _subtypeTranslator: ->
    @translator ||= new Customer.Filters.SubTypeTranslator()
